module.exports = __webpack_public_path__ + "static/img/sixiangdaode.091050fb.jpg";